module.exports = __webpack_public_path__ + "img/portraits_03_V.54fa1588.webp";